export class PersonModel {

    public id: number;
    public lastName: string;
    public name: string;
    public documentType: string;
    public documentNumber: number;
    public username: string;
    public types: any[];
    public completeName: string;
    public address: string;
    public photoFile: string;

    constructor() { }

}


// WEBPACK FOOTER //
// ./src/app/shared/models/person.model.ts